module.exports = __webpack_public_path__ + "assets/images/YellowShade.070ceee73b6e1f81c347425a6e5f3d6c.png";